/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import { connect } from "react-redux";
import { setLanguage } from "actions";
import "components/widgets/language/language.css";
import { ReactComponent as TrFlag } from "components/widgets/language/icon-lang-turkish.svg";
import { ReactComponent as EnFlag } from "components/widgets/language/icon-lang-english.svg";

class LanguageSelectorMobile extends Component {
  changeLanguage = (lang) => {
    this.props.setLanguage(lang);
  };

  getLanguage = () => {
    switch (this.props.language) {
      case "tr-TR":
        return "TUR";
      case "en-US":
        return "ENG";
      default:
        return "TUR";
    }
  };
  render() {
    return (
      <div className="col-md-12">
        <ul className="submenu langMenu">
          <li>
            <a href="#" onClick={() => this.changeLanguage("tr-TR")}>
              <TrFlag className="img-fluid flag" /> Türkçe
            </a>
          </li>
          <li>
            <a href="#" onClick={() => this.changeLanguage("en-US")}>
              <EnFlag className="img-fluid flag" /> English
            </a>
          </li>
          {/* <li>
                  <a href="#">
                    <img
                      src="img/icon-lang-francais.svg"
                      className="img-fluid"
                    />
                    Français
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img
                      src="img/icon-lang-deutsch.svg"
                      className="img-fluid"
                    />
                    Deutsch
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img
                      src="img/icon-lang-russian.svg"
                      className="img-fluid"
                    />
                    Pусский
                  </a>
                </li> */}
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.application.language,
  };
};

export default connect(mapStateToProps, { setLanguage })(
  LanguageSelectorMobile
);
